import React from 'react'
import { Summary } from './Summary'
import { Col, Row, Stack } from 'react-bootstrap'
import { CheckoutAlert } from './CheckoutAlert'
import { ActionAndProgress } from './ActionAndProgress'
import { CheckoutPanels } from './panels/CheckoutPanels'
import { BottomActions } from './BottomActions'

export const CheckoutBaseLayout = () => {
  return (
    <Row className="g-2">
      <Col md={9}>
        <Stack gap={2}>
          <CheckoutAlert />
          <ActionAndProgress />
          <CheckoutPanels />
          <BottomActions />
        </Stack>
      </Col>
      <Col md={3}>
        <Summary />
      </Col>
    </Row>
  )
}
